<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xjbEct/tc-custom/9781504094948.jpg?1730614331304" alt="This image is the cover for the book Listener"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Listener
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times–</i>bestselling author “masterfully combines historical thriller and supernatural horror . . . [for] fans of occult thrillers like those by Dean Koontz” (<i>Booklist</i>, starred review).</b><br/><br/> Economic collapse. Crushing unemployment and breadlines crowding city streets as crime spirals out of control. The Great Depression has enough misery for all, and some to spare. But for angel-faced grifter John Partlow, the American South in 1934 is a land of opportunity. The small-time confidence man stumbles into the big leagues when he partners up with beautiful hustler Ginger LaFrance. Seduced into her high stakes plot to kidnap the young children of a New Orleans shipping magnate, John realizes he’s in over his head when Ginger’s fierce desire to see her scheme succeed could mean a gruesome end for their innocent victims.<br/>  <br/> Unless young Nilla can wield her secret gift in time. Though she’s never heard the term, nine-year-old Nilla is a Listener—someone who can telepathically pick up on the thoughts of others like themselves. Nilla has started to communicate with another Listener—a young black man struggling to find his way as a porter at the Union Station. Their lives couldn’t be more different, and though they have never met, their shared bond is so strong that Curtis is ready to risk it all to answer her cry for help. But will it be enough to save two children from the merciless hands of hardened criminals?<br/><br/> “Race relations are one subject of this seductive slice of supernatural noir set in 1934 New Orleans . . . McCammon conjures believable characters whose sympathetic plight pulls the reader headlong into the novel’s volatile mix of crime and fantasy. Its tense finale, paced at breakneck speed, will have readers turning pages until its surprise-packed end.” —<i>Publishers Weekly </i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert McCammon
      </h2>
      
      <p class="authorDescription body article">Robert McCammon (b. 1952) is one of the country&rsquo;s most accomplished authors of modern horror and historical fiction, and a founder of the Horror Writers Association. Raised by his grandparents in Birmingham, Alabama, Bram Stoker and World Fantasy Award&ndash;winning McCammon published his first novel, the Revelations-inspired <I>Baal</I>, when he was only twenty-six. His writings continued in a supernatural vein throughout the 1980s, as he produced such bestselling titles as <I>Swan Song</I>, <I>The Wolf&rsquo;s Hour</I>, and <I>Stinger</I>.<BR /><BR /> In 1991, <I>Boy&rsquo;s Life</I> won the World Fantasy Award for best novel. After his next novel, <I>Gone South</I>, McCammon took a break from writing to spend more time with his family. He did not publish another novel until 2002&rsquo;s <I>Speaks the Nightbird</I>. Since then, he has followed &ldquo;problem-solver&rdquo; Matthew Corbett through seven sequels, in addition to writing several non-series books, including <I>The Border </I>and <I>The Listener</I>. McCammon still lives in Birmingham.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b7a453a6